import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SalesPartnerName } from '@/domain/contract/types/contract'
import { useAppStore } from '@/stores/useAppStore'

type SalesPartnerLogoProps = {
  name?: SalesPartnerName
  size?: SalesPartnerLogoSize
}

type SalesPartnerLogoName = 'ACE' | 'ACV' | 'ADAC' | 'Allianz' | 'EnBW' | 'Hyundai' | 'LBBW' | 'Yello'
type SalesPartnerLogoVariant = 'light' | 'dark'
type SalesPartnerLogoSize = 'medium' | 'small'

const SALES_PARTNER_LOGO_NAMES: Record<SalesPartnerName, SalesPartnerLogoName> = {
  ACE: 'ACE',
  ACV: 'ACV',
  ADAC: 'ADAC',
  ALLIANZ: 'Allianz',
  ENBW_COMMODITY: 'EnBW',
  ENMA: 'EnBW',
  HYUNDAI: 'Hyundai',
  LBBW: 'LBBW',
  MOVE: 'EnBW',
  YELLO: 'Yello'
}

const DEFAULT_SALES_PARTNER_LOGO_NAME: SalesPartnerLogoName = 'EnBW'

export const SalesPartnerLogo: FC<SalesPartnerLogoProps> = ({ name, size = 'medium' }) => {
  const { isDarkMode } = useAppStore()
  const { t } = useTranslation()

  const logoName: SalesPartnerLogoName = name ? SALES_PARTNER_LOGO_NAMES[name] : DEFAULT_SALES_PARTNER_LOGO_NAME
  const logoVariant: SalesPartnerLogoVariant = isDarkMode ? 'dark' : 'light'
  const logoSize: SalesPartnerLogoSize = size

  const description = t('contract.tariffBookings.salesPartnerLogoDescription', { salesPartnerLogoName: logoName })

  return <img src={`/partner-logos/${logoName}_${logoVariant}_${logoSize}.svg`} alt={description} />
}
